import {snakify} from '../snakify';
import {camelize} from '../camelize';
import {ISerializable} from 'cerialize';
import {ChecklistItemType} from '../../models/checklist-item-type';

export const ChecklistItemTypeTransformer: ISerializable = {
  Serialize(value: ChecklistItemType): string {
    if (value == null) {
      return null;
    }
    return snakify(ChecklistItemType[value]);
  },
  Deserialize(json: any): any {
    if (json) {
      const valueName = camelize(json, true);
      return ChecklistItemType[valueName];
    }
    return null;
  }
};
